import { render, staticRenderFns } from "./Plus.vue?vue&type=template&id=06ff5445&"
import script from "./Plus.vue?vue&type=script&lang=js&"
export * from "./Plus.vue?vue&type=script&lang=js&"
import style0 from "./Plus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports